import { useEffect, useMemo } from 'react'
import Swal from 'sweetalert2'
import { useCustomReducer } from '../../../../../base/customHooks'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import Table from '../../../../../components/Table'
import { ListBrandNoticeApi } from '../services/listBrandNoticeApi'
import { IBrandNotice } from '../models/models'
import IPButton from '../../../../../components/IPButton'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import moment from 'moment'
import { getBrandApi } from '../../../components/api'
import { IBrand } from '../../../components/models/models'

interface IBrandInformationState {
  brandNoticeData?: IBrandNotice[]
  brandList?: IBrand[]
}

function ListBrandNotices(props: BaseComponentWithContextProps) {
  const getInitialState = (): IBrandInformationState => {
    return {
      brandNoticeData: []
    }
  }

  const intialState = getInitialState()
  const navigate: any = useNavigate()
  const [state, setState] = useCustomReducer<IBrandInformationState>(intialState)

  useEffect(() => {
    getBrand()
  }, [])

  useEffect(() => {
    if (state.brandList != null && state.brandList?.length > 0)
      listBrandNotice()
  }, [state.brandList])


  const getBrand = async () => {
    const data: any[] = await getBrandApi()
    setState({ brandList: data })
  }

  const listBrandNotice = async () => {
    props.showLoading()
    try {
      const brandApi = new ListBrandNoticeApi({})
      const data = await brandApi.getBrandNotice()
      if (data) {
        setState({ brandNoticeData: data })
      }
      props.hideLoading()
    }
    catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  }

  const deleteBrandNotice = async (id: number) => {

  }

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'listId',
      },
      {
        Header: 'Marka',
        accessor: 'brand',
      },
      {
        Header: 'Sıra',
        accessor: 'order',
      },
      {
        Header: 'Başlangıç Tarihi',
        accessor: 'start',
      },
      {
        Header: 'Bitiş Tarihi',
        accessor: 'end',
      },
      {
        Header: 'Duyuru',
        accessor: 'text',
      },
      {
        Header: 'Durum',
        accessor: 'enabled',
      },
      // {
      //   Header: 'Oluşturulma Tarihi',
      //   accessor: 'created',
      // },
      {
        Header: 'İşlemler',
        accessor: 'funcs',
      },
    ],
    []
  )
  const tableData = useMemo(
    () =>
      state.brandNoticeData?.map((item, index) => {
        const data = {
          listId: index + 1,
          brand: state.brandList?.find(a => a.Id === item.BrandId)?.Name,
          order: item.OrderNo,
          start: moment(item.StartDate).format('DD.MM.YYYY HH:MM:SS'),
          end: moment(item.EndDate).format('DD.MM.YYYY HH:MM:SS'),
          text: <div dangerouslySetInnerHTML={{ __html: item.Description }} />,
          enabled: item.Enable === true ? "Aktif" : "Pasif",
          funcs: <div>
            <a
              data-action-type='edit'
              role='button'
              style={{ cursor: 'pointer' }}
              data-toggle='tooltip'
              data-original-title='Güncelle'
              onClick={() => {
                navigate('../admin/BrandPageOperation/BrandNotices/AddOrUpdateBrandNotices', { state: { brandList: item } })
              }}
            >
              <i className='icon-edit' style={{ fontSize: '1.2rem', color: 'green' }}></i>
            </a>
            <a
              data-action-type='delete'
              role='button'
              style={{ cursor: 'pointer' }}
              data-toggle='tooltip'
              data-original-title='Sil'
              onClick={() => deleteBrandNotice(item.Id)}
            >
              <i className='icon-trash-2' style={{ fontSize: '1.2rem', color: 'red' }}></i>
            </a>
          </div>,
          created: moment(item.CreatedDate).format('DD.MM.YYYY HH:MM:SS'),
        }
        return data
      }),
    [state.brandNoticeData]
  )

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className='h4'>Marka Duyuru Listesi</span>
            <div className='form-label col-lg-2' style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div className='buttonsuz'>
                <IPButton
                  type='button'
                  className='productCodeFileInput'
                  text={'Ekle'}
                  onClick={() => {
                    navigate(`../admin/BrandPageOperation/BrandNotices/AddOrUpdateBrandNotices`)
                  }}
                />
              </div>
            </div>
          </div>
          <div className='card-body'>
            <div className='m-4'>
              <Table
                columns={tableColumns}
                data={tableData}
                currentPage={0}
                columnCount={18}
                backgroundColor='red'
                color='white'
                textAlign={true}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

export default componentWithContext(ListBrandNotices)
